<template>
  <div class="feishu-sheet-container">
    <div v-if="loading" class="loading-container">
      <el-spinner size="large" />
      <p>加载中...</p>
    </div>
    <div v-else-if="error" class="error-container">
      <el-alert title="加载失败" :description="error" type="error" show-icon :closable="false" />
      <el-button type="primary" @click="loadSheetView" style="margin-top: 20px;">
        重试
      </el-button>
    </div>
    <div v-else id="SkyShowFeiShuSheetView" class="feishu-sheet-content"></div>
  </div>
</template>

<style scoped>
.feishu-sheet-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.feishu-sheet-content {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
  color: #666;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
}
</style>
<script>
import { getFeiShuSheetSignature } from '@/api/setting'

export default {
  name: 'SkyShowFeiShuSheetView',
  components: {},
  props: {
    documentUrl: {
      type: String
    }
  },
  data() {
    return {
      myComponent: null,
      loading: false,
      error: ''
    }
  },
  mounted() {
    this.loadSheetView()
  },
  methods: {
    loadSheetView() {
      if (!this.documentUrl) {
        this.error = '文档URL不能为空'
        return
      }
      this.loading = true
      this.error = ''

      var currentUrl = window.location.origin
      getFeiShuSheetSignature({ url: currentUrl })
        .then(res => {
          if (res.code === 0 && res.data && res.data.content) {
            var data = res.data.content
            this.myComponent = new window.DocComponentSdk({
              config: {
                extensions: {
                  suiteNavBar: {
                    disable: true
                  },
                  modal: {
                    outerMask: {
                      enable: true
                    }
                  },
                  share: {
                    enable: false
                  },
                  more_menu: {
                    enable: false
                  },
                  tabs: {
                    enable: false
                  },
                  content: {
                    mode: 'wide',
                    unscrollable: false,
                    readonly: false,
                    toolbox: {
                      enable: true
                    }
                  }
                }
              },
              src: this.documentUrl,
              mount: document.querySelector('#SkyShowFeiShuSheetView'), // 将组件挂在到哪个元素上
              auth: {
                openId: data.openId, // 当前登录用户的open id，要确保与生成 signature 使用的 user_access_token 相对应，使用 app_access_token 时此项不填。注意：仅云文档组件可使用app_access_token
                signature: data.signature, // 签名
                appId: data.appId, // 应用 appId
                timestamp: data.timestamp, // 时间戳（毫秒）
                nonceStr: data.noncestr, // 随机字符串
                url: currentUrl, // 第3步参与加密计算的url
                jsApiList: ['DocsComponent'], // 指定要使用的组件列表，请根据对应组件的开发文档填写。如云文档组件，填写['DocsComponent']
                locale: 'zh-CN' // 指定组件的国际化语言：en-US-英文、zh-CN-中文、ja-JP-日文
              },
              size: {
                height: '100%',
                width: '100%'
              },
              onAuthError: () => {
                this.error = '飞书文档认证失败'
                console.error('飞书文档认证失败')
              },
              onError: () => {
                this.error = '飞书文档加载失败'
                console.error('飞书文档加载失败')
              }
            })
            return this.myComponent.start()
          } else {
            throw new Error(res.msg || '获取飞书文档签名失败')
          }
        })
        .then(() => {
          console.log('飞书文档组件加载成功')
        })
        .catch(err => {
          this.error = err.message || '飞书文档加载异常'
          console.error('飞书文档加载错误:', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
